/**
 * External dependencies
 */
import { debounce } from 'lodash';
import { useMemoOne } from 'use-memo-one';
/**
 * WordPress dependencies
 */

import { useEffect } from '@wordpress/element';
/**
 * Debounces a function with Lodash's `debounce`. A new debounced function will
 * be returned and any scheduled calls cancelled if any of the arguments change,
 * including the function to debounce, so please wrap functions created on
 * render in components in `useCallback`.
 *
 * @param {...any} args Arguments passed to Lodash's `debounce`.
 *
 * @return {Function} Debounced function.
 */

export default function useDebounce() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var debounced = useMemoOne(function () {
    return debounce.apply(void 0, args);
  }, args);
  useEffect(function () {
    return function () {
      return debounced.cancel();
    };
  }, [debounced]);
  return debounced;
}
//# sourceMappingURL=index.js.map